export const NAME = 'ourPeople';
export const ID = 'our-people';
export const PERSON_NAME = 'personPublications';
export const PERSON_ID = 'person-publications';
